import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";
import type { ExtraTab } from "@/components/Templates/types";
import { TumorResponseCharts } from "./TumorResponseCharts";

/**
 * Analysis > Tumor Response.
 *
 * MetadataDashboardTemplate (table + filters over the `tumor_response` dataset)
 * plus a purpose-built "Response Charts" tab: a RECIST waterfall coloured by best
 * overall response, an ORR/DCR summary, and a PFS swimlane. Gated by the
 * `tumor-response` feature flag (DEMO-ONC-2026-01 only).
 */
export default function TumorResponse() {
  const { id } = useScopeParams();

  const extraTabs: ExtraTab[] = [
    {
      type: "custom",
      key: "response-charts",
      title: "Response Charts",
      component: TumorResponseCharts,
      toolbar: { showOnly: ["guide"] },
    },
  ];

  return (
    <PageTemplate
      title="Analysis: Tumor Response"
      tooltipText="RECIST v1.1 / iRECIST best overall response per subject — waterfall of best % change, ORR/DCR summary, and a progression-free-survival swimlane."
      type="tumor_response"
      constants={{
        wikiLink: "/wiki/guides/analysis-tumor-response",
        idLink: (subjectId: string) => `/${id}/subjects/overview/${subjectId}`,
      }}
      extraTabs={extraTabs}
    />
  );
}
